// action - state management
import setAuthToken from "Helpers/setAuthToken";
import {  ADMIN_LOADED,
    AUTH_FAIL,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS, GET_SETTINGS} from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    token: localStorage.getItem("MILITARY_USER_TOKEN"),
    isAuthenticated: false,
    loading: true,
    user: {},
    settings:{}
};

const accountReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case LOGIN_SUCCESS:
      localStorage.setItem("MILITARY_USER_TOKEN", payload.token);
      setAuthToken(payload.token)
      return {
        ...state,
        token: payload?.token,
        isAuthenticated: true,
        loading: false,
      };
    case ADMIN_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload,
      };
    case LOGOUT_SUCCESS:
      localStorage.removeItem("MILITARY_USER_TOKEN");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: true,
      };
      case GET_SETTINGS:
      return {
        ...state,
        settings:payload
      };
    case AUTH_FAIL:
      localStorage.removeItem("MILITARY_USER_TOKEN");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: true,
        user: {},
      };
     
    default:
      return state;
    }
};

export default accountReducer;
